import { baseFunc } from "./server-base";

export const StarsLanguages = baseFunc("StarsLanguages")
export const StarsSections = baseFunc("StarsSectionsLang")
export const StarsCategories = baseFunc("StarsCategoriesLang")
export const StarsInformation = baseFunc("StarsInformation")
export const StarsTeam = baseFunc("StarsTeamLang")
export const StarsSafety= baseFunc("StarsSafetyLang")
export const StarsSingleTeam= baseFunc("StarsTeamByIDLang")
export const StarsSubCategoriesLang = baseFunc("StarsSubCategoriesLang")
export const StarsSubChildCat = baseFunc("StarsSubChildCatLang");

export const FosterLogin = baseFunc("StarsLogin")
export const FosterMoods = baseFunc("StarsMoodsLang")
export const FosterMoodLog = baseFunc("StarsInsertMoodLog")
export const FosterSubCatDetails = baseFunc("StarsSubCatDetailsLang");
